import { supabase } from './supabase';

export interface ShiftLogEntry {
  id: string;
  tenant_id: string;
  dsr_report_id: string;
  entry_time: string;
  entry_text: string;
  created_by: string | null;
  created_at: string;
  updated_at: string;
  is_deleted: boolean;
}

export interface AddShiftLogParams {
  dsrReportId: string;
  tenantId: string;
  entryTime: string;
  entryText: string;
  userId: string;
}

export async function getShiftLogEntries(
  dsrReportId: string,
): Promise<ShiftLogEntry[]> {
  const { data, error } = await supabase
    .from('dsr_shift_logs')
    .select('*')
    .eq('dsr_report_id', dsrReportId)
    .eq('is_deleted', false)
    .order('entry_time', { ascending: true });
  if (error) throw new Error(error.message);
  return (data ?? []) as ShiftLogEntry[];
}

export async function addShiftLogEntry(
  params: AddShiftLogParams,
): Promise<ShiftLogEntry> {
  const { data, error } = await supabase
    .from('dsr_shift_logs')
    .insert({
      tenant_id: params.tenantId,
      dsr_report_id: params.dsrReportId,
      entry_time: params.entryTime,
      entry_text: params.entryText,
      created_by: params.userId,
    })
    .select('*')
    .single();
  if (error) throw new Error(error.message);
  return data as ShiftLogEntry;
}

export async function updateShiftLogEntry(
  entryId: string,
  patch: { entry_text?: string; entry_time?: string },
): Promise<ShiftLogEntry> {
  const { data, error } = await supabase
    .from('dsr_shift_logs')
    .update({ ...patch, updated_at: new Date().toISOString() })
    .eq('id', entryId)
    .select('*')
    .single();
  if (error) throw new Error(error.message);
  return data as ShiftLogEntry;
}

export async function deleteShiftLogEntry(entryId: string): Promise<void> {
  const { error } = await supabase
    .from('dsr_shift_logs')
    .update({ is_deleted: true, updated_at: new Date().toISOString() })
    .eq('id', entryId);
  if (error) throw new Error(error.message);
}
